export const extractValueFromStateSetter = <T,>(setter: (v: T) => void):T => {
    let value: any;
        setter((val:any) => {
            value = val;
            return val;
        })
    return value as T;
}